import { useLogger } from '@direct-frontend/modules-logger';
import React, { ReactNode, useMemo } from 'react';

/** Пропсы компонента для отслеживания ошибок, отображаемых пользователю*/
interface ErrorLoggerProps {
    /** Название категории ошибки*/
    name: string;
    /** Код ошибки*/
    errorCode: string;
    /** Компонент для отображения ошибки*/
    children: ReactNode;
}

/**
 * Компонент для отслеживания ошибок, отображаемых пользователю
 * @kind component
 */
export const ErrorLogger = ({ name, errorCode, children }: ErrorLoggerProps) => {
    const logNodeInfo = useMemo(
        () => ({
            name: name,
            attrs: { errorCode },
        }),
        [name, errorCode],
    );
    const { LogProvider } = useLogger(logNodeInfo);

    return <LogProvider>{children}</LogProvider>;
};
